import {timingMetricTypes, timings} from './constants';
import {clearDeferMetrics, getDeferMetrics, logDuration} from '@servicenow/ui-utils';
import {isPerfMetricsEnabled} from './metrics';

let debounceMetrics = {};
//Have to do this to avoid circular dependency between utils and metrics packages
let deferMetrics = getDeferMetrics();

export const clearTimingMetrics = () => {
	debounceMetrics = {};
	clearDeferMetrics();
	deferMetrics = getDeferMetrics();
};

export const logTimingMetrics = (type, duration = 0, componentName) => {
	if (!isPerfMetricsEnabled()) return;
	switch (type) {
		case timingMetricTypes.DEFER:
			logDuration(deferMetrics, duration, componentName);
			break;
		case timingMetricTypes.DEBOUNCE:
			logDuration(debounceMetrics, duration, componentName);
			break;
	}
};

export function getCountersHistogram() {
	return {
		[timingMetricTypes.DEFER]: getHistogram(deferMetrics),
		[timingMetricTypes.DEBOUNCE]: getHistogram(debounceMetrics)
	};
}

function getHistogram(metrics) {
	const histogram = {
		[timings.LOWER_BOUNDARY]: {},
		[timings.MIDDLE]: {},
		[timings.UPPER_BOUNDARY]: {}
	};
	Object.keys(metrics).forEach(componentName => {
		const delayTimeArray = metrics[componentName] || [];
		delayTimeArray.forEach(delayTime => {
			if (delayTime <= 50) {
				histogram[timings.LOWER_BOUNDARY][componentName] =
					(histogram[timings.LOWER_BOUNDARY][componentName]
						? histogram[timings.LOWER_BOUNDARY][componentName]
						: 0) + 1;
			} else if (delayTime > 100) {
				histogram[timings.UPPER_BOUNDARY][componentName] =
					(histogram[timings.UPPER_BOUNDARY][componentName]
						? histogram[timings.UPPER_BOUNDARY][componentName]
						: 0) + 1;
			} else {
				histogram[timings.MIDDLE][componentName] =
					(histogram[timings.MIDDLE][componentName]
						? histogram[timings.MIDDLE][componentName]
						: 0) + 1;
			}
		});
	});
	return histogram;
}
